











import Vue from 'vue';
import {
  Modal,
  ModalMixin,
  AsyncBtn,
  notify,
} from 'mycorems-app-shared';
import { PaymentMethod, Modal as ModalElement } from '../types';
import { remove } from './payment-method';

interface Data {
  task: Promise<void>|null
}

export default Vue.extend({
  mixins: [ModalMixin],
  components: {
    Modal,
    PaymentMethodItem: () => import('./PaymentMethodItem.vue'),
    AsyncBtn,
  },
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    remove() {
      this.task = remove(this.paymentMethod.id);
      this.task.then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify.success('Payment method deleted.');
      });
    },
  },
});
